type TFunc = (key: string, options?: Record<string, unknown>) => string;

/**
 * Format a "last seen" timestamp as a short relative string.
 * Returns:
 *   - "never" if null/undefined
 *   - "just now" if < 1 minute
 *   - "Xm" / "Xh" / "Xd" for minute/hour/day buckets up to a week
 *   - locale date for older
 */
export function formatLastSeen(
  lastSeenAt: number | null | undefined,
  t: TFunc,
  lang: "lt" | "en"
): string {
  if (!lastSeenAt) return t("last_seen_never");

  const diffMs = Date.now() - lastSeenAt;
  if (diffMs < 60_000) return t("last_seen_just_now");

  const minutes = Math.floor(diffMs / 60_000);
  if (minutes < 60) return t("last_seen_minutes", { count: minutes });

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return t("last_seen_hours", { count: hours });

  const days = Math.floor(hours / 24);
  if (days < 7) return t("last_seen_days", { count: days });

  const locale = lang === "lt" ? "lt-LT" : "en-US";
  return new Date(lastSeenAt).toLocaleDateString(locale, {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}
